import React, { useState } from "react";
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import CallIcon from '@mui/icons-material/Call';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import "./buttons.css"

const Buttons = () => {

  /* Pop Up States */
  const [isOpen2, setIsOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  
  const openPopup = () => {
  setIsOpen(true);
  setIsClosing(false);
  };
  
  const closePopup = () => {
  setIsClosing(true);
  
      setTimeout(() => {
          setIsOpen(false);
          setIsClosing(false);
      }, 300); // muss zur CSS-Animation passen
  };

  return (
    <div className="buttons_main">
      <div className="buttons_sub">
        <a href="tel:+4953316041">
          <Box>
            <Fab title="callButton" variant="extended" size="large" sx={{ bgcolor: "#b2a365de;", color: "white", fontSize: 13, fontFamily: "Barlow", textTransform: "none", p: "0px 70px 0px 12px" }}>
              <CallIcon
                sx={{ color: "white", fontSize: 30, mr: "0px" }} />
            </Fab>
          </Box>
        </a>
      </div>

      <div className="buttons_sub" onClick={openPopup}>
          <Box>
            <Fab title="onlineBooking" variant="extended" size="large" sx={{ bgcolor: "#b2a365de;", fontSize: 13, color: "white", fontFamily: "Barlow", textTransform: "none", p: "0px 70px 0px 13px" }}>
              <CalendarMonthIcon sx={{ color: "white", fontSize: 30, mr: "0px" }} />
            </Fab>
          </Box>
      </div>

      {isOpen2 && (
        <div className={`popupOverlay ${isClosing ? "closing" : ""}`} onClick={closePopup}>
            <div className={`popupContent ${isClosing ? "closing" : ""}`} onClick={(e) => e.stopPropagation()}>
            
                <button className="closeBtn" onClick={closePopup}>
                    ✕
                </button>

                <h2>Nur für Neupatienten</h2>

                <br></br>

                <p>
                    Nach Ihrer Online-Terminbuchung erhalten Sie einen Anamnesebogen per E-Mail.
                    Bitte füllen Sie diesen umgehend vollständig aus und senden ihn an uns zurück, da der Termin andernfalls storniert wird.
                </p>

                <a href="https://iie-systems.de/online-termin-kfo-medefindt" target="_blank" rel="noreferrer" className="popupBtn">
                    Bestätigen und zur Terminbuchung
                </a>

            </div>
        </div>
        )}

      {/*
        <div className="buttons_sub" onClick={window.toggleDrFlexAppointments}>
          <Box>
            <Fab title="onlineBooking" variant="extended" size="large" sx={{ bgcolor: "#b2a365de;", fontSize: 13, color: "white", fontFamily: "Barlow", textTransform: "none", p: "0px 70px 0px 13px" }}>
              <CalendarMonthIcon sx={{ color: "white", fontSize: 30, mr: "0px" }} />
            </Fab>
          </Box>
        </div>
      */}
    </div>

  )
}

export default Buttons